<template>
  <section class="hero-section">
    <div class="hero-section__background">
      <img src="@/assets/img/TopMain.jpg" alt="Kaon R Interior" />
      <div class="hero-section__overlay"></div>
    </div>
    
    <div class="hero-section__content">
      <div class="container">
        <div class="hero-section__text">
          <h1 class="hero-section__title animate-fadeInUp">
            <span class="hero-section__subtitle">南青山の癒しと美容の専門サロン</span>
            <img src="@/assets/img/kaonR_logo.svg" alt="Kaon R" class="hero-section__logo" />
          </h1>
          <p class="hero-section__description animate-fadeInUp" style="animation-delay: 0.2s">
            初期費用0円、1時間1,440円から<br>
            本格的な設備を備えた完全個室のレンタルサロン
          </p>
          <div class="hero-section__actions animate-fadeInUp" style="animation-delay: 0.4s">
            <base-button
              variant="primary"
              size="lg"
              to="/reserve"
              icon="fas fa-calendar-check"
            >
              ご予約・見学受付はこちら
            </base-button>
            <base-button
              variant="outline"
              size="lg"
              to="/about"
              icon="fas fa-arrow-right"
            >
              詳しく見る
            </base-button>
          </div>
        </div>
      </div>
    </div>
    
    <div class="hero-section__scroll">
      <span>Scroll</span>
      <i class="fas fa-chevron-down"></i>
    </div>
  </section>
</template>

<script>
import BaseButton from '@/components/common/BaseButton.vue';

export default {
  name: 'HeroSection',
  components: {
    BaseButton
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.hero-section {
  position: relative;
  height: 100vh;
  min-height: 600px;
  display: flex;
  align-items: center;
  overflow: hidden;
  
  &__background {
    @include absolute-full;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  
  &__overlay {
    @include overlay(rgba($black, 0.4));
    background: linear-gradient(
      to bottom,
      rgba($black, 0.2) 0%,
      rgba($black, 0.5) 50%,
      rgba($black, 0.7) 100%
    );
  }
  
  &__content {
    position: relative;
    z-index: 2;
    width: 100%;
    padding: $spacing-2xl 0;
  }
  
  &__text {
    max-width: 800px;
    text-align: center;
    margin: 0 auto;
    color: $white;
  }
  
  &__subtitle {
    display: block;
    font-size: $font-size-lg;
    font-weight: 400;
    margin-bottom: $spacing-sm;
    opacity: 0.9;
    letter-spacing: 0.1em;
    
    @include media-breakpoint-down(md) {
      font-size: $font-size-md;
    }
  }
  
  &__title {
    font-size: $font-size-5xl;
    font-weight: 700;
    margin-bottom: $spacing-lg;
    color: $white;
    letter-spacing: 0.05em;
    
    @include media-breakpoint-down(md) {
      font-size: $font-size-4xl;
    }
    
    @include media-breakpoint-down(sm) {
      font-size: $font-size-3xl;
    }
  }
  
  &__logo {
    display: block;
    width: 300px;
    height: auto;
    margin: $spacing-md auto 0;
    filter: none; // 白色のまま表示
    
    @include media-breakpoint-down(md) {
      width: 250px;
    }
    
    @include media-breakpoint-down(sm) {
      width: 200px;
    }
  }
  
  &__description {
    font-size: $font-size-xl;
    line-height: 1.8;
    margin-bottom: $spacing-2xl;
    opacity: 0.95;
    
    @include media-breakpoint-down(md) {
      font-size: $font-size-lg;
      margin-bottom: $spacing-xl;
    }
  }
  
  &__actions {
    display: flex;
    gap: $spacing-md;
    justify-content: center;
    flex-wrap: wrap;
    
    @include media-breakpoint-down(sm) {
      flex-direction: column;
      align-items: center;
      
      .base-button {
        width: 100%;
        max-width: 300px;
      }
    }
  }
  
  &__scroll {
    position: absolute;
    bottom: $spacing-xl;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    color: $white;
    cursor: pointer;
    animation: bounce 2s infinite;
    
    span {
      display: block;
      font-size: $font-size-sm;
      letter-spacing: 0.1em;
      margin-bottom: $spacing-xs;
      opacity: 0.8;
    }
    
    i {
      font-size: $font-size-lg;
      opacity: 0.6;
    }
  }
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateX(-50%) translateY(0);
  }
  40% {
    transform: translateX(-50%) translateY(-10px);
  }
  60% {
    transform: translateX(-50%) translateY(-5px);
  }
}</style>